import axios from 'axios';

export default {
  namespaced: true,
  state: {
    selectedLanguage: sessionStorage.getItem('selectedLanguage') || 'KOR',
    translations: JSON.parse(localStorage.getItem('translations')) || {},
    availableLanguages: ['KOR', 'ENG', 'CHI'],
  },
  mutations: {
    SET_LANGUAGE(state, language) {
      state.selectedLanguage = language;
      sessionStorage.setItem('selectedLanguage', language);
    },
    SET_TRANSLATIONS(state, translations) {
      state.translations = translations;
      localStorage.setItem('translations', JSON.stringify(translations));
    }
  },
  actions: {
    async changeLanguage({ commit, dispatch, state, rootState }, language) {
      console.log("changeLanguage called", language);
      if (state.selectedLanguage !== language || !Object.keys(state.translations).length) {
        const apiPreUrl = rootState.url.apiPreUrl;
        try {
      
          const response = await axios.get(apiPreUrl + `/api/translation/${language}`);
          commit('SET_LANGUAGE', language);
          commit('SET_TRANSLATIONS', response.data);
    
          commit('app/resetDataLoadState', null, { root: true });
          dispatch('app/fetchList', null, { root: true });
        } catch (error) {
          console.error("error", error);
        }
      } else {

        const translations = JSON.parse(localStorage.getItem('translations')) || {};
        commit('SET_TRANSLATIONS', translations);
    
        commit('app/resetDataLoadState', null, { root: true });
        dispatch('app/fetchList', null, { root: true });
      }
    }
  },
  getters: {
    selectedLanguage: state => state.selectedLanguage,
    translations: state => state.translations,
    availableLanguages: state => state.availableLanguages,
  },
};
